<ng-container *ngIf="discountType && discountBucketDetails && !isLoading">
  <div
    class="on-invoice-discounts-container"
    *ngIf="discountBucketDetails.onInvoiceDiscounts && discountBucketDetails.onInvoiceDiscounts.length > 0"
  >
    <mat-list>
      <mat-list-item *ngFor="let onInvoiceDiscountsDetail of discountBucketDetails.onInvoiceDiscounts">
        <span>{{ onInvoiceDiscountsDetail.group }}</span>
        <span>{{ onInvoiceDiscountsDetail.discountValue + '%' }}</span>
      </mat-list-item>
    </mat-list>
  </div>
  <div
    class="off-invoice-discounts-container"
    *ngIf="discountBucketDetails.offInvoiceDiscounts && discountBucketDetails.offInvoiceDiscounts.length > 0"
  >
    <h3>{{ 'discounts.offInvoiceDiscounts' | cxTranslate }}</h3>
    <mat-list>
      <mat-list-item *ngFor="let offInvoiceDiscountsDetail of discountBucketDetails.offInvoiceDiscounts">
        <span>{{ offInvoiceDiscountsDetail.group }}</span>
        <span>{{ offInvoiceDiscountsDetail.discountValue + '%' }}</span>
      </mat-list-item>
    </mat-list>
  </div>
</ng-container>
